var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@lucidlink/uicore';
export const WorkspaceFooterLayout = ({ children }) => {
    return (_jsx(Box, { grow: 1, kind: "level2", orientation: "vertical", radius: "m", shrink: 1, children: _jsx(Box, { grow: 1, orientation: "vertical", scrollableY: true, shrink: 1, children: children }) }));
};
_react_refresh_temp_1 = WorkspaceFooterLayout;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceFooterLayout");
